// extracted by mini-css-extract-plugin
export var hero = "Hero-module--hero--52veU";
export var heroDescription = "Hero-module--heroDescription--OzLGO";
export var heroDescriptionInner = "Hero-module--heroDescriptionInner--29VR8";
export var heroDescriptionQuestion = "Hero-module--heroDescriptionQuestion--aGnTJ";
export var heroImg = "Hero-module--heroImg--hVShg";
export var heroInner = "Hero-module--heroInner--ZPPSg";
export var heroSubHeadline = "Hero-module--heroSubHeadline--VCY0o";
export var heroSvg = "Hero-module--heroSvg--aoGuh";
export var heroVerisart = "Hero-module--heroVerisart--RQYDH";